<template>
  <div class="container" :class="[seasonClass, groupClass, tvClass, query.group === '1' && roundStr === 'C' ? 'groupRoundC' : '']">
    <div class="screen" :style="pageStyle">
      <img class="logo1" v-if="seasonClass === 'season1'" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_welcom_logo1.png" alt="">
      <img class="logo2" v-if="seasonClass === 'season1'" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_welcom_logo2.png" alt="">
      <img class="qr" @click="toFullOrExit" v-if="seasonClass === 'season2'" src="https://cdn.spbcn.org/chineseWord/applets/images/2025/2025_season3_photo_qr.png" alt="">
      <div class="content">
        <div class="season2-logo" v-if="seasonClass === 'season2'">
          <img class="season2-logo1" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/spbcn-cebsb.png" alt="">
          <img class="season2-logo2" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season3/season3.png" alt="">
        </div>
        <div class="content-title" v-if="seasonClass === 'season1'">
          <template v-if="query.group === '1'">
            <div class="title title2">小组赛{{ roundStr }}轮{{levelInfo(query.level).cn}}</div>
            <div class="title enTitle">Group Competition Round {{ roundStr }} {{levelInfo(query.level).en}}</div>
          </template>
          <template v-if="query.group === '2'">
            <div class="title">无组别{{ roundStr }}轮</div>
            <div class="title enTitle">Mixed Group Competition Round {{ roundStr }}</div>
          </template>
          <div class="title">排行榜</div>
          <div class="title enTitle mb">RANKING</div>
        </div>
        <div class="rank-title" v-if="seasonClass === 'season2'">
          <template v-if="query.group === '1'">
            <div class="title title2">小组赛-{{levelInfo(query.level).cn}}晋级名单</div>
            <div class="title enTitle">Group Competition {{levelInfo(query.level).en}}</div>
          </template>
          <template v-if="query.group === '2'">
            <div class="title">无组别</div>
            <div class="title enTitle">Mixed Group Competition</div>
          </template>
        </div>
        <div class="rank-bg">
          <div class="rank-tip" v-if="query.group === '1' && seasonClass === 'season1'">
            *排名只显示前五名<br/>
            *Only the top five spellers are listed.
          </div>
          <div class="rank-flex">
            <div class="rank-half">
              <div class="rank-item rank-item1">
                <div class="rank-index" :class="round === 6 ? 'rank-index2' : ''">排名</div>
                <div class="rank-num" :class="round === 6 ? 'rank-num2 rank-num-tit' : ''">号码牌</div>
                <div class="rank-name" :class="round === 6 ? 'rank-name2' : ''">姓名</div>
                <div class="rank-index" v-if="round === 1">分数</div>
              </div>
              <div class="rank-item" :class="[query.group === '2' && roundStr === 'B' ? 'rank-item-final' : '', 'rank-item-'+index, round === 1 ? 'bb' : '']" v-for="(item, index) of rank1" :key="index">
                <img class="rank-img" v-if="query.group === '2' && roundStr === 'B' && item.rank < 4" :src="'https://cdn.spbcn.org/chineseWord/applets/images/rank'+ item.rank +'.png'" alt="">
                <img class="rank-img2" v-else-if="query.group === '1' && roundStr === 'C' && item.rank < 4" :src="'https://cdn.spbcn.org/chineseWord/applets/images/rank'+ item.rank +'.png'" alt="">
                <div v-else class="rank-index">
                  {{ item.rank }}
                </div>
                <div class="rank-num" :class="round === 6 ? 'rank-num2' : ''">{{ addZero(item.matchNum) }}</div>
                <div class="rank-name" :class="round === 6 ? 'rank-name2' : ''">{{ item.userName }}</div>
                <div class="rank-score" v-if="round === 1">{{ item.roundOne }}</div>
              </div>
            </div>
            <div class="rank-half" v-if="rank2.length">
              <div class="rank-item rank-item1">
                <div class="rank-index">排名</div>
                <div class="rank-num">号码牌</div>
                <div class="rank-name">姓名</div>
                <div class="rank-name" v-if="round === 1">分数</div>
              </div>
              <div class="rank-item" v-for="(item, index) of rank2" :key="index">
                <div class="rank-index">{{ item.rank }}</div>
                <div class="rank-num">{{ addZero(item.matchNum) }}</div>
                <div class="rank-name">{{ item.userName }}</div>
                <div class="rank-score" v-if="round === 1">{{ item.roundOne }}</div>
              </div>
            </div>
            <div class="rank-half" v-if="rank3.length">
              <div class="rank-item rank-item1">
                <div class="rank-index">排名</div>
                <div class="rank-num">号码牌</div>
                <div class="rank-name">姓名</div>
                <div class="rank-name" v-if="round === 1">分数</div>
              </div>
              <div class="rank-item" v-for="(item, index) of rank3" :key="index">
                <div class="rank-index">{{ item.rank }}</div>
                <div class="rank-num">{{ addZero(item.matchNum) }}</div>
                <div class="rank-name">{{ item.userName }}</div>
                <div class="rank-score" v-if="round === 1">{{ item.roundOne }}</div>
              </div>
            </div>
          </div>
          <div class="rank-desc">
            <div class="cn">{{rankDesc}}</div>
            <div class="en word-break">{{rankDescEn}}</div>
          </div>
        </div>
      </div>
      <img class="qr" @click="getRankList" v-if="seasonClass === 'season2'" src="/semiWelcome" alt="">
      <img src="../../assets/img/fs.png" class="fullscreen" @click="toFullOrExit" alt="">
      <img src="../../assets/img/refresh.png" class="fullscreen refresh" @click="getRankList" alt="">
      <img src="../../assets/img/fs.png" v-if="query.group === '1'" class="fullscreen-top" @click="toFullOrExit" alt="">
      <img src="../../assets/img/refresh.png" v-if="query.group === '1'" class="fullscreen-top refresh" @click="getRankList" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      seasonClass: '',
      groupClass: '',
      tvClass: '',
      screenWidth: 0,
      screenHeight: 0,
      dict_group: this.$userInfo.dict_group(),
      pageStyle: {
        width: '100%'
      },
      query: {},
      rank1: [],
      rank2: [],
      rank3: [],
      rankDesc: '',
      rankDescEn: '',
      roundStr: '',
      round: 1 // 有组别轮次
      // test: {
      //   transform: 'scale(1)',
      //   'transform-origin': 'left top'
      // }
    }
  },
  mounted () {
    this.getScreenSize()
    window.addEventListener('resize', this.getScreenSize)
  },
  beforeDestory () {
    window.removeEventListener('resize', this.getScreenSize)
  },
  created () {
    document.title = '汉英双拼大会'
    this.query = this.$route.query
    if (this.query.season === '2022~2023') {
      this.seasonClass = 'season1'
    } else if (this.query.season === '2023~2024') {
      this.seasonClass = 'season2'
    } else {
      this.seasonClass = 'season2'
    }
    // this.groupClass = 'group' + this.query.group
    if (this.query.TV) {
      this.groupClass = ''
    } else {
      this.groupClass = 'group' + this.query.group
    }

    this.tvClass = this.query.TV
    this.roundStr = this.query.round
    if (this.query.group === '1') {
      this.round = this.query.round === 'A' ? 1 : this.query.round === 'B' ? 2 : this.query.round === 'C' ? 4 : 1
    } else {
      this.round = this.query.round === 'A' ? 1 : this.query.round === 'B' ? 6 : 1
    }

    this.getRankList()

    const round = this.query.round
    if (round === 'A') {
      this.rankDesc = '本部分共计10题,总分10分,排名相同者以号码牌顺序排列'
      this.rankDescEn = 'This round has 10 questions, with 1 point each. For spellers with the same ranking, their names are displayed in the order of their number tags.'
    }
  },
  methods: {
    // round
    // 1 有组别A轮分数倒序，---小组赛A轮
    // 2 有组别AB轮综合分数倒序，---小组赛B轮
    // 3 有组别抽签顺序倒序，
    // 4 有组别 C轮分数倒序 ---小组赛C轮
    // 6 无组别
    getRankList () {
      this.$http.get('slabForm/queryNationalGroupList', {
        params: {
          activityType: this.query.activityType,
          season: this.query.season,
          raceSchedule: 4,
          round: this.round,
          level: this.query.level,
          isGroup: this.query.group
        },
        showLoading: false
      }).then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            if (this.query.group === '1') { // 有组别
              item.rank = this.roundStr === 'A' ? item.rankOne : this.roundStr === 'B' ? item.rankTwo : item.groupRank
            } else if (this.query.group === '2') { // 无组别
              item.rank = this.roundStr === 'A' ? item.rankOne : item.drawRank
            }
          })
          this.rank1 = res.data.slice(0, 10)
          console.log(res.data.length)
          if (res.data.length > 10) {
            this.rank2 = res.data.slice(10, 20)
          }
          if (res.data.length > 20) {
            this.rank3 = res.data.slice(20, 30)
          }
          console.log(this.rank1, this.rank2, this.rank3)
        }
      })
    },
    getScreenSize () {
      // const w = window.innerWidth // 屏幕宽
      const h = window.innerHeight // 屏幕高
      // 1920/1080
      const calcWidth = 1920 * h / 1080
      // console.log(calcWidth, w)
      // if (calcWidth < w) {
      if (this.seasonClass === 'season1') {
        this.pageStyle.width = parseInt(calcWidth) + 'px'
      }
      // } else {
      //   this.pageStyle.width = '100%'
      // }
      // const scale = h / 1080
      // this.test.transform = `scale(${scale})`
      // this.test.width = '1920px'
      // this.test.height = '1080px'

      // console.log(this.test)
    },
    requestFullScreen () {
      const de = document.documentElement
      if (de.requestFullscreen) {
        de.requestFullscreen()
      } else if (de.mozRequestFullScreen) {
        de.mozRequestFullScreen()
      } else if (de.webkitRequestFullScreen) {
        de.webkitRequestFullScreen()
      }
    },
    exitFullscreen () {
      const de = document
      if (de.exitFullscreen) {
        de.exitFullscreen()
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen()
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen()
      }
    },
    toFullOrExit () {
      this.isFull = !this.isFull
      if (this.isFull) {
        // this.fullImg = require('@/assets/img/efs.png')
        this.requestFullScreen()
      } else {
        // this.fullImg = require('@/assets/img/fs.png')
        this.exitFullscreen()
      }
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    levelInfo (level) {
      return level ? this.dict_group.find(item => item.dictCode === Number(level)) : {}
    }
  }

}
</script>
<style scoped lang="less">
.container{
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.screen{
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  color: #000;
  font-family: 'regular';
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.logo1{
  position: absolute;
  left: 60px;
  top: 50px;
  width: auto;
  height: 67px;
}
.logo2{
  position: absolute;
  right: 120px;
  top: 50px;
  width: auto;
  height: 70px;
}
.content{
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_rank_titlebg.png);
  box-sizing: border-box;
  position: relative;
  .title{
    text-align: center;
    font-size: 52px;
    color: #bb9138;
    text-shadow: -2px -2px 0px #ffffff, 2px 1px 0px #ffffff;
  }
  .title2{
    font-size: 42px;
  }
  .enTitle{
    font-size: 22px;
    margin-bottom: 10px;
  }
  .mb{
    margin-bottom: 200px;
  }
  .content-title{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_rank_titlebg1.png);
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    width: 500px;
    height: 450px;
    margin: 0 auto;
    padding-top: 30px;
    padding-right: 20px;
    box-sizing: border-box;
    position: relative;
    z-index: 10;
  }
}
.rank-bg{
  height: 90vh;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.rank-tip{
  font-size: 16px;
  color: #FFF;
  text-align: right;
  position: absolute;
  top: 210px;
  right: 260px;
}
.rank-desc{
  width: 70%;
  color: #bb9138;
  // text-shadow: -2px -1px 0px #ffffff, 2px 2px 0px #ffffff;
  text-align: center;
  margin: 28px auto 0;
  .cn{
    font-size: 32px;
  }
  .en{
    font-size: 28px;
  }
}
.rank-flex{
  margin-top: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rank-item{
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4px 0;
}
.bb{
  border-bottom: 1px dashed #666;
}
.rank-half{
  margin-top: 10px;
  height: 576px;
}
.rank-index{
  // width: 73px;
  // height: 115px;
  // text-align: center;
  // line-height: 106px;
  // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_rank_icon.png);
  // background-repeat: no-repeat;
  // background-size: cover;
  // background-position: center;
  font-size: 42px;
  font-family: fzcsk;
  color: #fff;
  width: 68px;
  margin-left: 4px;
}
.rank-index2{
  width: 130px;
  margin-left: 0;
}
.rank-num{
  width: 120px;
  font-size: 42px;
  font-family: fzcsk;
  color: #f7b52c;
}
.rank-num2{
  width: 140px;
}
.rank-num-tit{
  // margin-left: -40px;
  position: relative;
  left: -20px;
}
.rank-name{
  width: 150px;
  font-size: 38px;
  font-family: fzcsk;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 20px;
  color: #FFF;
  // text-shadow: -2px -2px 2px #ffffff, 2px 2px 0px #ffffff;
}
.rank-name2{
  width: 250px;
  text-align: center;
}
.rank-score{
  width: 60px;
  font-size: 42px;
}
.fullscreen{
  width: 24px;
  height: 24px;
  position: fixed;
  left: 10px;
  bottom: 10px;
  cursor: pointer;
}
.fullscreen-top{
  width: 24px;
  height: 24px;
  position: fixed;
  left: 10px;
  top: 10px;
  cursor: pointer;
}
.refresh{
  left: 50px;
}
.rank-item-final{
  margin: 30px 0;
  .rank-name{
    font-family: shufa;
    font-size: 86px;
    text-shadow: -2px -2px 0px #000, 2px 2px 0px #000;
  }
  .rank-img{
    width: 64px;
    height: auto;
  }
  .rank-num{
    font-size: 62px;
    margin-right: 20px;
  }
}
.rank-img2{
  width: 30px;
  margin-right: 60px;
}
.season1{
  background-color: #B81C25;
  .screen{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_rankbg.png);
  }
  .rank-bg{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_rank_titlebg2.png);
  }
  .rank-item1{
    display: none;
  }
}
.season2{
  .rank-bg{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/rankbg.png);
    height: 82vh;
  }
  .screen{
    display: flex;
    align-items: center;
    justify-content: center;
    // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/season2bg.png);
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/2025/season3_bg_pure.jpg);
  }
  .qr{
    height: 100%;
    width: auto;
  }
  .rank-tip{
    color: #000;
  }
  .rank-item{
    margin: 0;
  }
  .rank-index{
    color: #000;
  }
  .rank-name{
    color: #000;
    font-size: 28px;
  }
  .rank-flex{
    margin-top: 164px;
  }
  .rank-num{
    color: #B81C25;
  }
  .rank-item-final {
    margin: 20px;
    .rank-name{
      font-family: shufa;
      font-size: 68px;
      text-shadow: none;
    }
    .rank-num{
      font-size: 68px;
      margin: 0 40px;
    }
  }
  .rank-desc{
    color: #000;
    position: absolute;
    width: 86%;
    left: 0;
    right: 0;
    bottom: 20px;
    .cn{
      font-size: 26px;
    }
    .en{
      font-size: 18px;
    }
  }
  .season2-logo{
    position: absolute;
    left: 20px;
    right: 20px;
    top: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img{
      height: 60px;
      width: auto;
    }
  }
  .rank-title{
    font-family: regular;
    margin-top: 120px;
    .title{
      font-size: 40px;
      color: #000;
      text-shadow: none;
    }
    .enTitle{
      font-size: 28px;
    }
  }
  .rank-item1{
    margin-bottom: 20px;
    .rank-index, .rank-name, .rank-num{
      font-size: 26px;
      font-family: regular;
      color: #000;
    }
  }
}

// 小组赛适配5.5米*2.5米大屏
.season2.group1{
  .season2-logo{
    top: 30px;
    img{
      height: 40px;
    }
  }
  .rank-bg{
    bottom: 16px;
  }
  .rank-title{
    // margin-top: 72px;
    .title{
      // font-size: 24px;
    }
    .enTitle{
      // font-size: 18px;
    }
  }
  .rank-flex{
    // margin-top: 140px;
  }
  .rank-index{
    width: 40px;
    font-size: 34px;
  }
  .rank-num{
    width: 100px;
    font-size: 34px;
  }
  .rank-name{
    font-size: 32px;
    width: 160px;
  }
  .rank-item{
    margin: 6px 0;
  }
  .rank-desc{
    width: 70%;
    bottom: -10px;
    .cn{
      font-size: 18px;
    }
    .en{
      font-size: 14px
    }
  }
}

.groupRoundC{
  .rank-item{
    .rank-img2{
      width: 30px;
      margin-right: 40px;
    }
    .rank-index{
      width: 72px;
      height: 42px;
      line-height: 42px;
      padding-left: 7px;
      box-sizing: border-box;
      margin-left: 0;
    }
  }
}
// 适配电视
.season2.TV {
  .qr{
    display: none;
  }
  .redbar{
    right: 200px;
  }
}
</style>
